import { useTeamList } from "@/hooks/queryHooks/teamHooks";
import { useUserList } from "@/hooks/queryHooks/userHooks";

export const Approver = ({
  approverType,
  approverId,
  tenantId,
}: {
  approverType?: string;
  approverId?: string;
  tenantId: string;
}) => {
  const { data: usersData } = useUserList(tenantId);
  const { data: teamsData } = useTeamList(tenantId);

  if (!approverType || !approverId || approverType === "none") {
    return <div>No approval required</div>;
  }
  if (approverType === "user") {
    const user = usersData?.find((u) => u.id === approverId);
    return (
      <div>
        User: {user ? `${user.firstName} ${user.lastName}` : "<Unknown>"}
      </div>
    );
  }
  if (approverType === "team") {
    const team = teamsData?.find((t) => t.id === approverId);
    return <div>Team: {team ? `${team.name}` : "<Unknown>"}</div>;
  }
  return null;
};
